import { Component } from '@angular/core';
import { LandingHeroComponent } from '../hero/landing-hero.component';
import { LandingServicesComponent } from '../services/landing-services.component';
import { LandingSupportComponent } from '../support/landing-support.component';

/**
 * "Business Services" menu content (hero/services/support) — rendered as the
 * default child of LandingComponent's <router-outlet>, alongside other
 * sections (e.g. /marketplace) that share the same header/footer shell.
 * Renamed from LandingPageComponent so the name matches the nav entry it
 * belongs to, once business-services split off from the shell into its own
 * standalone components (no declaring NgModule needed for either).
 */
@Component({
  selector: 'app-business-services-page',
  templateUrl: './business-services-page.component.html',
  styleUrls: ['./business-services-page.component.scss'],
  imports: [LandingHeroComponent, LandingServicesComponent, LandingSupportComponent],
})
export class BusinessServicesPageComponent {}
